import { useMemo } from 'react';
import { Autocomplete, Box } from '@mui/material';
import { FormikContextType } from 'formik';
import TooltipText from '../inputComponents/TooltipText';
import TextFieldWrapper from '../../common/TextFieldWrapper/TextFieldWrapper';
import { barcodeType } from '../../constants/lists';
import { AddPrizeState } from '../../types/componentTypes/prizeComponentTypes';

interface BarcodeTypeComponentProps {
    formik: FormikContextType<AddPrizeState>;
}

type barcodeItemType = {
    value: string;
    label: string;
};

export const BarcodeTypeComponent = ({ formik }: BarcodeTypeComponentProps) => {
    const barcodeTypeMap = useMemo(
        () =>
            barcodeType.reduce(
                (acc: { [key: string]: barcodeItemType }, item: barcodeItemType) => {
                    acc[item.value] = item;
                    return acc;
                },
                {}
            ),
        []
    );

    return (
        <Box>
            <TooltipText
                dataTestId='barcode-type-tooltip'
                styleName='prize-tooltip-text'
                text='Barcode Type'
                textVariant='body1'
                tooltip='Select the barcode type that will be used for the prize voucher distribution.'
            />
            <Autocomplete
                disableClearable={true}
                sx={{ background: 'white' }}
                fullWidth
                data-testid='barcode-type-dropdown'
                options={barcodeType}
                value={barcodeTypeMap[formik.values.barcode_type]}
                onChange={(_event, value: barcodeItemType) =>
                    formik.handleChange({
                        target: {
                            name: 'barcode_type',
                            value: parseInt(value.value, 10),
                        },
                    })
                }
                renderInput={(params) => (
                    <TextFieldWrapper
                        {...params}
                        placeholder='Select Barcode Type'
                    />
                )}
            />
        </Box>
    );
};
